import React, { useState, useEffect } from 'react';
import {
  Box,
  Flex,
  Button,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  FormControl,
  FormLabel,
  Image,
  Icon,
  Input,
  Spinner,
  Container,
  IconButton,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import ProfileIconSvg from'../Assets/icons/profileIcon.svg';

import WebNav from '../Components/WebNav';
import { useGetLoggedInUser, useUpdateProfile } from '../utils/user.api';
// import { useUploadMedia } from '../utils/media.api';
import { toast } from 'react-toastify';

const Profile = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const getLoginedUser = useGetLoggedInUser();
  const useUpdateProfileMutation = useUpdateProfile();
  const { isLoading } = useUpdateProfileMutation;

  // const uploadMediaMutation = useUploadMedia();

  const [userDetails, setUserDetails] = useState({
    username: '',
    new_email: '',
    new_password: '',
  });

  const handleInputChange = e => {
    const { name, value } = e.target;
    setUserDetails(prevDetails => ({ ...prevDetails, [name]: value }));
  };

  const handleEdit = async () => {
    try {
      const userData = {
        username: userDetails?.username,
        new_password: '',
        new_email: userDetails?.new_email,
      };

      await useUpdateProfileMutation.mutateAsync(userData);
      toast.success('Profile edited successfully');
      onClose();
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    if (getLoginedUser.isError) {
      return;
    }

    if (getLoginedUser.data && getLoginedUser.data) {
      const { username, email } = getLoginedUser?.data;
      // console.log('username', username, email)
      setUserDetails({
        username:username,
        new_email:email,
      });
    }
  }, [getLoginedUser.data, getLoginedUser.isError]);

  return (
    <Box bg="#21234a" height='100vh'>
      <WebNav />
      

      <Box ml="1.5rem">
        <Text fontWeight="bold" color="#B7b0dd" fontSize="30px" ml="30px">
          Profile
        </Text>
      </Box>

      <Container py={4} bg="#2d2a76" borderRadius=".5rem">
  <Flex direction="column" justify="center" align="center" className="h-100">
    {/* Profile Card */}
    <Box mb={{ base: 4, lg: 0 }} borderRadius="10px" width="400px">
      <Box  borderRadius="1rem">
        <Flex direction="column" align="center" bg="#2d2a76" color="white" borderRadius=".5rem" height="150px" p={4}>
          {/* Profile Image and Edit Icon */}
          <IconButton
            aria-label="Profile image"
            borderRadius="full"
            bg="transparent"
            _hover={{ bg: 'transparent' }}
            icon={
              <Image
                src={ProfileIconSvg}
                boxSize="50px"
                borderRadius="full"
                boxShadow="0 0 0 1px white"
              />
            }
          />
          <Box textAlign="center" mt={3}>
            <Text as="h5" fontWeight="bold">
              {getLoginedUser?.data?.username}
            </Text>
            <Icon
              onClick={onOpen}
              cursor="pointer"
              as={FaEdit}
              mb={3}
            />
          </Box>
        </Flex>
      </Box>

      {/* Information Section */}
      <Box bg="#2d2a76" borderRadius=".5rem" >
        <Text as="h6" fontWeight="bold" color="white">
          Information
        </Text>
        <hr mt={0} mb={4} />
        <Flex direction="column">
          <Box mb={3}>
            <Text as="h7" fontWeight="bold" color="white">
              Email: {getLoginedUser?.data?.email}
            </Text>
            
          </Box>
        </Flex>
      </Box>
    </Box>
  </Flex>
</Container>


      <Modal isOpen={isOpen} onClose={onClose} bg="#21234a">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Edit Profile</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

          <FormControl mb="3">
              <FormLabel>Name</FormLabel>
              <Input
              disabled
                type="text"
                name="username"
                value={userDetails.username}
                onChange={handleInputChange}
              />
            </FormControl>
            <FormControl mb="3">
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="new_email"
                value={userDetails.new_email}
                onChange={handleInputChange}
              />
            </FormControl>

            <FormControl mb="3">
              <FormLabel>Password</FormLabel>
              <Input
                type="text"
                name="password"
                placeholder='leave blank if no change'
                value={userDetails.new_password}
                onChange={handleInputChange}
              />
            </FormControl>
          
            <Button backgroundColor="#21234a" color='white' onClick={handleEdit} >
              {isLoading ? <Spinner size="xs" /> : 'Update Profile'}
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Profile;
